import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import apiFunctions from "../../../Services/apiFunctions";
import { useParams } from "react-router-dom";
import DatePicker from "react-datepicker/dist/react-datepicker";
import { getMonth, getYear } from "date-fns";
import * as moment from "moment";
import { _years, _months } from "../../../GlobalData/date";
function EmailLinkVerification(props) {
  const years = _years;
  const months = _months;
  const { key } = useParams();
  const [data, setData] = useState("");
  const [body, setBody] = useState();
  const [isVerified, setIsVerified] = useState(false);
  const [isAllreadyVerified, setIsAllreadyVerified] = useState(false);
  const checkDateValidity = (e, name) => {
    if (e.target.value === "") {
      setError(name, {
        type: "manual",
        message: "Date is required.",
      });
    } else {
      var date = moment(e.target.value, "MM/DD/YYYY");
      if (date.isValid()) {
        clearErrors(name);
      } else {
        clearErrors(name);
        setError(name, {
          type: "manual",
          message: "Invalid Date",
        });
      }
    }
  };
  useEffect(() => {
    apiFunctions
      .saveData("Preregistration/EmailLinkVerificationStatus", key)
      .then((response) => {
        if (response.code === 0) {
          setIsAllreadyVerified(true);
          setBody(
            <div className=" mt-2 alert alert-success" role="alert">
              Your email already have been verified.
            </div>
          );
        }
      });
  }, [key]);
  const onDataChanged = (name, val) => {
    setData(val);
  };
  const onSubmit = () => {
    if (data === undefined || data === "") {
      setError("dob", {
        type: "manual",
        message: "Date is required.",
      });
      return;
    }
    if (errors.dob !== undefined) return;
    apiFunctions
      .saveData("Preregistration/EmailLinkVerification", {
        key: key,
        dob: new Date(data).toDateString(),
      })
      .then((response) => {
        if (response.code === 0) {
          setIsVerified(true);
          setBody(
            <div className=" mt-2 alert alert-success" role="alert">
              Your email successfully verified. When your Covid test report is
              ready, it will be emailed to you.
            </div>
          );
        } else {
          setBody(
            <div className="mt-2 alert alert-danger" role="alert">
              Invalid Validation Link or Date of Birth
            </div>
          );
        }
      });
  };
  const { errors, handleSubmit, clearErrors, setError } = useForm({
    mode: "onBlur",
    reValidateMode: "onBlur",
  });
  return key === undefined ? (
    <div className="mt-2 alert alert-danger" role="alert">
      Invalid Validation Link
    </div>
  ) : (
    <>
      {!isAllreadyVerified && (
        <div className="mx-auto px-2">
          <div
            style={{ marginTop: "10px" }}
            className=" col-md-12 col-sx-12 col-lg-12 col-sm-12"
          >
            <div className="card">
              <div className="card-header cardHeaderColor">
                <div className="card-title">Covid-19 (email verification)</div>
                <div className="custom-card-title "></div>
              </div>
              <div className="card-body">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div>
                    <div className="row">
                      <div className="form-group col-12 ">
                        <label>
                          Please enter your date of birth to proceed verifying
                          your email.
                        </label>
                      </div>
                      <div className="form-group col-md-6 col-sm-12 col-xs-12 col-lg-6">
                        <label>
                          Date of Birth <span className="is-required">*</span>
                        </label>
                        <div
                          className={`${errors.dob ? "is-invalid-date" : ""}`}
                        >
                          <DatePicker
                            maxDate={new Date()}
                            renderCustomHeader={({
                              date,
                              changeYear,
                              changeMonth,
                              decreaseMonth,
                              increaseMonth,
                              prevMonthButtonDisabled,
                              nextMonthButtonDisabled,
                            }) => (
                              <div
                                style={{
                                  margin: 10,
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <button
                                  onClick={decreaseMonth}
                                  disabled={prevMonthButtonDisabled}
                                >
                                  {"<"}
                                </button>
                                <select
                                  value={getYear(date)}
                                  onChange={({ target: { value } }) =>
                                    changeYear(value)
                                  }
                                >
                                  {years.map((option) => (
                                    <option key={option} value={option}>
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                <select
                                  value={months[getMonth(date)]}
                                  onChange={({ target: { value } }) =>
                                    changeMonth(months.indexOf(value))
                                  }
                                >
                                  {months.map((option) => (
                                    <option key={option} value={option}>
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                <button
                                  onClick={increaseMonth}
                                  disabled={nextMonthButtonDisabled}
                                >
                                  {">"}
                                </button>
                              </div>
                            )}
                            name="dob"
                            selected={data}
                            onChange={(e) => onDataChanged("dob", e)}
                            onBlur={(e) => checkDateValidity(e, "dob")}
                            className="form-control"
                          />
                        </div>

                        <ErrorMessage
                          className="invalid-feedback"
                          name="firstName"
                          as="div"
                          errors={errors}
                        />
                      </div>
                      <div className="mt-3 pt-1 col-md-2 col-sm-12 col-xs-12 col-lg-2 offset-lg-2 offset-md-2">
                        <button
                          disabled={isVerified}
                          className="btn  btn-block btn-primary "
                          type="submit"
                        >
                          Verify
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
      {body}
    </>
  );
}
export default EmailLinkVerification;
